import styled from "styled-components";
import { colors, typography, dimensions } from "modules/common/styles";

const AuthTextBox = styled.div`
  margin: auto;
  background: #fff;
  width: 214px;
  height: 72px;
  border-radius: 50px;
  padding-top: 14px;

  h2 {
    color: #023372;
    font-size: 22px;
    font-weight: 500;
    margin: 0px;
    text-align: center;
  }
`;

const AuthBox = styled.div`
  background-color: ${colors.colorWhite};
  padding: 30px;
  box-shadow: 0px 4px 24px rgb(0,0,0 ,0.5);
  border-radius: 30px !important;
  text-align: left;
  max-width: 500px;
  width: 100%;

  @media only screen and (max-width: 540px){
    max-width: 400px;
  }

  @media only screen and (max-width: 420px){
    max-width: 340px;
  }
  
  input {
  padding-right: 40px;
  text-overflow: ellipsis;
  }

  .otp-title {
    font-size: 19px !important;
  }

  .forgot-password-title {
    font-size: 24px !important;
  }

	.outer-authbox-title > .authbox-title {
		font-size: 32px !important;
	}

  .authbox-title {
    margin-bottom: 6px;
    font-size: 32px;
    font-style: normal;
    font-weight: 800;
    letter-spacing: 0.2em;
    text-transform: uppercase;
    color: #010101;
  }

  .authbox-desc {
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    margin-bottom: 22px;
    display: flex;
    align-items: center;
    color: #868686;
  }

  .icon {
    font-size: 17px;
  }

  @media only screen and (max-width: 767px) {
    .darkblue-btn {
      left: 0 !important;
    }
  }

  @media (max-width: 768px) {

    .otp-title {
      font-size: 16px;
    }

    .forgot-password-title {
      font-size: 20px;
    }

    .otp-input-wrapper {
      margin: -14px;
    }
  }

  .otp {
    input {
      height: auto;
      padding: 10px 0px 10px 0px;
      font-size: 15px;
      font-weight: 700;
      text-align: center;
    }
  }

  h2 {
    color: #023372;
    font-size: 18px;
    font-weight: 500;
    margin: 0 0 45px;
  }

  p {
    letter-spacing: 0.48px;
    color: #626262;
    font-weight: 600;
    font-size: 16px;
    margin-bottom: 30px;
  }

  label {
    letter-spacing: 0.26px;
    text-align: left;
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    color: #010101;
    display: block;
    position: relative !important;
    left: 0;
    padding: 0;
    top: 0;
    text-transform: capitalize;
    background: transparent;
    margin-bottom: 6px;
  }

  input {
    padding-left: 20px;
    font-size: 14px;
    font-weight: 400;
    outline: 0;
    border: 1px solid transparent;
    border-radius: 10px;
    background: #ffffff;
    color: #010101;
    box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.1);
    height: 48px;
   
    &::placeholder{
      color: #B1B1B1;
    }

    &:focus {
      outline: 0;
    }

    input:-internal-autofill-selected {
      background: none;
    }
  }

  .line {
    width: 100%;
    text-align: center;
    border-bottom: 1px solid #f0f1ff;
    line-height: 0.1em;
    margin: 35px;
    margin-bottom: 40px;
    margin-left: 0%;
  }

  .line span {
    background: #fff;
    padding: 0 10px;
    color: #afafb5;
    font-size: 14px;
  }
`;

const Links = styled.div`
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;

  a {
    color: ${colors.colorPrimary};
    font-weight: 500;
  }
`;

const Avatar = styled.div`
  img {
    display: block;
    width: 100px;
    height: 100px;
    border-radius: 50px;
  }
`;

const ProfileWrapper = styled.div`
  display: flex;
`;

const ProfileColumn = styled.div`
  flex: 1;
  padding-right: 40px;

  &:last-of-type {
    padding: 0;
  }
`;

const ColumnTitle = styled.h4`
  text-transform: uppercase;
  font-weight: ${typography.fontWeightMedium};
  border-bottom: 1px dotted ${colors.colorShadowGray};
  padding-bottom: ${dimensions.unitSpacing}px;
  font-size: 14px;
  margin: ${dimensions.coreSpacing}px 0;
`;

export {
  AuthBox,
  Links,
  ProfileWrapper,
  ProfileColumn,
  ColumnTitle,
  Avatar,
  AuthTextBox,
};



// WEBPACK FOOTER //
// src/modules/auth/styles.js